/**
 * Comments JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Comments
 */
class Comments {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * All comment-related events
     * @return {void}
     */
    events() {
        if ( typeof window.DustPress !== 'undefined' ) {
            if ( window.DustPress.Comments ) {
                window.DustPress.Comments.addListener( this.dpCommentsStateCb );
            }
        }
    }

    /**
     * Callback for DustPress Comments state change. Reloads recaptcha if state is `reply` or `success`.
     * @param {string} state      refers to the state commenting is in
     * @param {object} $container the current commenting section as a jQuery object
     */
    dpCommentsStateCb( state, $container ) {

        // Return early if not reply or success. Success is called after pagination is done.
        if ( state !== 'reply' && state !== 'success' ) {
            return;
        }

        // Remove onclick attribute set by WP. This is needed to make sure the attribute gets removed also when using
        // pagination
        if ( state === 'success' ) {
            const $replyLinks = $container.find( '.comment-reply-link' );
            $.each( $replyLinks, ( idx, link ) => {
                    link.removeAttribute( 'onclick' );
                }
            );
        }

        // Check if the Simple Google ReCaptcha plugin has added the sgr_recaptcha variable. If so reset the recaptcha.
        // The captcha will not work if this is not done.
        // Disable linting since we cannot rename the sgr_recaptcha variable.
        /* eslint-disable */
        if ( typeof sgr_recaptcha !== "undefined" && typeof sgr_recaptcha.site_key !== "undefined" && typeof grecaptcha !== "undefined" ) {
        /* eslint-enable */
            // Set a short timeout so that the script has time to copy the form before we start manipulating it.
            setTimeout( () => {

                // Get the first sgr-recaptcha element.
                const sgrDiv = document.getElementsByClassName( 'sgr-recaptcha' )[0];
                if ( sgrDiv ) {

                    // Empty the element from any old recaptcha data.
                    sgrDiv.innerHTML = '';

                    // Render recaptcha. Disable linting since we cannot rename the sgr_recaptcha variable.
                    /* eslint-disable */
                    grecaptcha.render( sgrDiv, {'sitekey': sgr_recaptcha.site_key });
                    /* eslint-enable */
                }
            }, 500 );
        }
    };

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.events();
    }
}

// Export the class reference.
module.exports = Comments;



// WEBPACK FOOTER //
// ./assets/scripts/comments.js